// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const FormatAlignJustify = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="nonzero"
      d="M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"
    />
  </svg>
);

export default FormatAlignJustify;
